/**
 * Formats a number of cents as a currency string.
 * @param amount The number of cents to format.
 * @param undefinedBehavior The string to return if cents is undefined.
 * @returns The formatted currency string.
 **/
export function moneyFormatter(amount, options) {
    const { undefinedBehavior, hideDollarSign, isDollars } = options || {};
    if (!amount) {
        if (amount !== 0)
            return undefinedBehavior || '';
    }
    if (!isDollars) {
        amount = amount / 100;
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: options?.decimalPlaces || options?.decimalPlaces === 0 ? options.decimalPlaces : 2,
    });
    const output = formatter.format(amount);
    if (hideDollarSign) {
        return output.replace('$', '');
    }
    if (options?.style === 'accounting') {
        if (amount < 0) {
            return `( ${output.replace('-', '')} )`;
        }
    }
    return output.trim();
}
/**
 * Converts a number of cents to a number of dollars.
 * @param cents The number of cents to convert.
 * @returns The number of dollars.
 **/
export const centsToDollars = (cents) => {
    return cents / 100;
};
/**
 * Converts a number of dollars to a number of cents.
 * @param dollars The number of dollars to convert.
 * @returns The number of cents.

 **/
export const dollarsToCents = (dollars) => {
    return dollars * 100;
};
//# sourceMappingURL=money-formatter.js.map